/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import RenderObject from "App/geometry/objects/object";
import AbstractGeometry from "App/geometry/objects_geometry/abstract_geometry";
import VertexDataDescriptor from "App/geometry/objects_geometry/vertex_data_descriptor";
import Factory from "App/geometry/objects_geometry/factory";

export default
class Particles extends AbstractGeometry {

    public static TypeName: string = "particles";

    constructor(aObject: RenderObject) {
        super(aObject);
    }

    public static create(aObject: RenderObject) {
        return new Particles(aObject);
    }

    public loadData() {
        let data: any = {
            positions: null
        };

        data.positions = new Float32Array(this.properties.points);

        let repetitionTrafo = this.object.getElement().getRepetitionTransformation();
        if (repetitionTrafo) {
            data.positions =
                AbstractGeometry.transformArray(
                    data.positions,
                    this.properties.vertexCount,
                    new Float32Array(repetitionTrafo)
                );
        }

        this.setDescriptors(data);

        data = null;
    }

    protected setDescriptors(aData: any) {
        // fill mesh with data
        let positionAttributeSize = this.object.getPositionAttributeSize();
        this.vertexCount = aData.positions.byteLength / (positionAttributeSize * 4);

        this.positionsDesc = new VertexDataDescriptor(
            "positions",
            positionAttributeSize,
            aData.positions.length / positionAttributeSize,
            "FLOAT",
            4,
            0,
            aData.positions
        );
    }
}

Factory.register(Particles);